<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="factureForm" @submit="addFacture" :validation-schema="factureSchema">
        <div class="row mb-10">
          <div class="col-6 d-flex justify-content-start">
            <div class="form-check me-3" v-if="!true">
              <Field name="showAib" type="checkbox" 
                id="11" 
                :value="true"
                :unchecked-value="false"
                class="form-check-input"
                v-model="showAib" />
              <label class="form-check-label" for="11">
                Appliquer l'AIB
              </label>
            </div>
          </div>

          <div class="col-6 d-flex justify-content-end">
            <div class="form-group radio-group-right">
              <div class="d-flex align-items-center gap-15">
                <div class="form-check me-3" v-if="nbElementsofContrat > 0">
                  <Field name="natureFacture" type="radio" :value="3" id="3" class="form-check-input"
                    v-model="natureFacture" />
                  <label class="form-check-label" for="3">
                    Loyer & Electricité
                  </label>
                </div>
                
                <div class="form-check me-3">
                  <Field name="natureFacture" type="radio" :value="0" id="0" class="form-check-input"
                    v-model="natureFacture" :checked="natureFacture == 0" />
                  <label class="form-check-label" for="0">
                    Loyer
                  </label>
                </div>

                <div class="form-check me-3" v-if="nbElementsofContrat > 0">
                  <Field name="natureFacture" type="radio" :value="2" id="2" class="form-check-input"
                    v-model="natureFacture" :checked="natureFacture == 2" />
                  <label class="form-check-label" for="2">
                    Electricité
                  </label>
                </div>
              </div>
              <ErrorMessage name="natureFacture" class="text-danger" />
            </div>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-md-9">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-10">
                Contrat <span class="text-danger">*</span>
              </label>
              <Field name="contrat" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" contratholder="Rechercher une contrat"
                  :filter-results="false" @select="contratSelect" :min-chars="3" :resolve-on-load="false" :delay="0"
                  :searchable="true" :options-limit="300" :options="async (query) => {
                    return await fetchContrats(query)
                  }" noResultText="Aucun enregistrement trouvé" noOptionsText="Tapez au moins trois caractères" />
              </Field>
              <ErrorMessage name="contrat" class="text-danger" />
            </div>
          </div>
          

          <div class="col-md-3">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-10">
                Date facture <span class="text-danger">*</span>
              </label>
              <Field name="date_facture" type="date" :value="date_facture"
                class="form-control shadow-none fs-md-15 text-black" contratholder="Entrer la date de facture" />
              <ErrorMessage name="date_facture" class="text-danger" />
            </div>
          </div>

          <div :class=" showAib ? 'col-md-2 mb-3' : 'col-md-3 mb-3'">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black mb-10">
                Mois
                <span class="text-danger">*</span>
              </label>
              <Field name="mois" v-model="mois" type="text" v-slot="{ field }">
                <Multiselect :searchable="true" :options="[
                  { value: 0, label: 'Janvier' },
                  { value: 1, label: 'Février' },
                  { value: 2, label: 'Mars' },
                  { value: 3, label: 'Avril' },
                  { value: 4, label: 'Mai' },
                  { value: 5, label: 'Juin' },
                  { value: 6, label: 'Juillet' },
                  { value: 7, label: 'Août' },
                  { value: 8, label: 'Septembre' },
                  { value: 9, label: 'Octobre' },
                  { value: 10, label: 'Novembre' },
                  { value: 11, label: 'Décembre' },
                ]" v-model="field.value" v-bind="field" contratholder="Sélectionner le mois" />
              </Field>
              <ErrorMessage name="mois" class="text-danger" />
            </div>
          </div>


          <div :class=" showAib ? 'col-md-2 mb-3' : 'col-md-3 mb-3'">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black mb-10">
                Année
                <span class="text-danger">*</span>
              </label>
              <Field name="annee" v-slot="{ field }">
                <Multiselect :options="years" :searchable="true" v-model="field.value" v-bind="field"
                  contratholder="Sélectionner une année" />
              </Field>
              <ErrorMessage name="annee" class="text-danger" />
            </div>
          </div>

          <div class="col-md-2 mb-3" v-if="showAib">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black mb-10">
                AIB
                <span class="text-danger">*</span>
              </label>
              <Field name="aib" v-model="aib" type="text" v-slot="{ field }">
                <Multiselect :searchable="true" :disabled="true" :options="[
                  { value: 1, label: '1 %' },
                  { value: 5, label: '5 %' },
                ]" v-model="field.value" v-bind="field" contratholder="Sélectionner un élément" />
              </Field>
              <ErrorMessage name="aib" class="text-danger" />
            </div>
          </div>

          <div class="col-md-2" v-if="showAib">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-10">
                Montant Aib <span class="text-danger">*</span>
              </label>
              <Field name="montant_aib" v-model="montant_aib" type="number" :disabled="true"
                class="form-control shadow-none fs-md-15 text-black" contratholder="Entrer le montant" />
              <ErrorMessage name="montant_aib" class="text-danger" />
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-10">
                Montant facture <span class="text-danger">*</span>
              </label>
              <Field name="montant_facture" v-model="montant_facture" type="number" :disabled="true"
                class="form-control shadow-none fs-md-15 text-black" contratholder="Entrer le montant" />
              <ErrorMessage name="montant_facture" class="text-danger" />
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date limite de paiement <span class="text-danger">*</span>
              </label>
              <Field name="dateLimit" type="date"  v-model="dateLimit"
              class="form-control shadow-none fs-md-15 text-black"/>
              <ErrorMessage name="dateLimit" class="text-danger"/>
            </div>
          </div>

          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center ">
              <button v-if="checkPermission('AddContrat')" class="btn btn-success me-3" v-show="!auclic" type="submit">
                Enregistrer
              </button>
              <button class="btn btn-success me-3" v-show="!auclic" @click="normalise" type="submit">
                Enregistrer & Normaliser
              </button>
              <button class="btn btn-success" type="button" v-show="auclic" disabled>
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                <span class="visually-hidden">Loading...</span>
              </button>
              <router-link to="/liste-facture" class="btn btn-danger"><i
                  class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>
<script lang="ts">

import { defineComponent, onMounted, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, format_Date, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect';
import axios from 'axios';
import JwtService from "@/services/JwtService";


export default defineComponent({
  name: "AddFacture",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  setup: () => {
    const factureSchema = Yup.object().shape({
      natureFacture: Yup.number().required("La nature est obligatoire"),
      date_facture: Yup.string().required("Date facture est obligatoire."),
      montant_facture: Yup.string().required("Montant est obligatoire."),
      contrat: Yup.string().required("Contrat est obligatoire."),
      mois: Yup.number().required("Le mois est obligatoire."),
      annee: Yup.string().required("L'année est obligatoire."),
      dateLimit: Yup.date().required('La date limite de paiement est obligatoire'),
    });

    const dateLimit = ref();
    const contrats = ref();
    const lesContrats = ref([]);
    const leContrat = ref<any>(null);
    const mois = ref();
    const aib = ref();
    const showAib = ref(false);
    const nbElementsofContrat = ref(0);
    const montant_aib = ref(0);
    const normaliser = ref(false);
    const contratOptions = ref([]);
    const natureFacture = ref(0)
    const factureForm = ref(null);
    const montant_facture = ref();
    const contrat = ref();
    const auclic = ref(false)
    const date_facture = ref(new Date().toISOString().slice(0, 10));
    const estTaxable = ref(false); 
    //const contratOptions = ref();
    const router = useRouter();
    const currentYear = new Date().getFullYear();
    const minPeriode = ref(`${currentYear}-01`);
    const year = ref(new Date().getFullYear());
    const years = ref(
      Array.from({ length: 3 }, (_, i) => {
         const year = currentYear - 1;
        return { value: year + i, label: year + i };
      })
    );

    //  const currentYear = new Date().getFullYear();
    // const years = ref(
    //   Array.from({ length: 3 }, (_, i) => {
    //     const year = currentYear - 1;
    //     return { value: year + i, label: year + i };
    //   })
    // );

    const normalise = () => {
      normaliser.value = true;
    }

    const arrondiir = (value) => {
       return Math.round(value);
    }

    watch(aib, (newValue) => {
      console.log("AIB changed: ", newValue);
      if (newValue !== null && newValue !== undefined) {
        console.log("yes: ", newValue);
        // montant_aib.value = montant_facture.value * (newValue == 0 ? 0.01 : 0.05);
        if(estTaxable.value) {
          const montantHT = montant_facture.value / ((1 + (newValue == 1 ? 0.01 : 0.05)) * 1.18);
          montant_aib.value = arrondiir(montantHT * (newValue == 1 ? 0.01 : 0.05));
        } else {
          const montantHT = montant_facture.value / (1 + (newValue == 1 ? 0.01 : 0.05));
          montant_aib.value = montantHT * (newValue == 1 ? 0.01 : 0.05);
        }

      } else {
        montant_aib.value = 0;
      }
    });


    const addFacture = async (values, { resetForm }) => {
      auclic.value = true;
      values["normalise"] = normaliser.value;

      console.log("VALUES ==> ", values)
      ApiService.post("/factures", values)
        .then(({ data }) => {
          if (data.code == 201) {
            normaliser.value = false;
            success(data.message);
            auclic.value = false;
            resetForm();
            router.push({ name: "ListeFacturePage" });
          }
        }).catch(({ response }) => {
          normaliser.value = false;
          auclic.value = false;
          error(response.data.message);
        });
    };

    const noOptionsTextAbb = ref("Tapez au moins trois caractères");
    const nooptions = "Aucun enregistrement trouvé";
    const noResultText = "Aucun enregistrement trouvé";

    const contratSelect = async (value) => {
      const contrat = await axios.get(`/contrats/${value}`);
      const contratD = contrat.data.data;
      const contratData = contrat.data.data.contratElements;
      nbElementsofContrat.value = contratData.length;
      leContrat.value = contratD;
      // AIB
      if(contratD.aib && contratD.aib > 0) {
        showAib.value = true;
        aib.value = contratD.aib;
      } else {
        showAib.value = false;
        aib.value = 0;
      }
      // estTaxable
      if(contratD.loyerHT != contratD.loyerTTC) {
        estTaxable.value = true;
      } else {
        estTaxable.value = false;
      }

      await calculerMontant();
      console.log(contrat.data.data, "contrato")
      console.log(contratData, "contratDato")
      console.log(value, "contrat")
    };

    const fetchContrats = async (key) => {
      try {
        const response = await axios.get(`/contrats/recherche/${key}`);
        const contratsData = response.data.data;
        console.log(response)
        console.log('CONNNNTRAARARARA ===== > ', contratsData);
        lesContrats.value = contratsData;
        contratOptions.value = contratsData.map((contrat) => (
          {
            value: `${contrat.id}`,
            label: `${contrat.reference} - ${contrat?.codePlace}-[${contrat.nomMarchand}] ${contrat.dateMiseEnService ? "[" + format_Date(contrat.dateMiseEnService) + "]" : ''}`,
          }));
        console.log(contratOptions.value, "rrrrrrrrrrrrrr")
        if (contratOptions.value.length == 0) {
          noOptionsTextAbb.value = noResultText;
        } else {
          noOptionsTextAbb.value = 'Tapez au moins trois caractères';
        }
        return contratOptions.value;
      } catch (error) {
        //
      }
    }

    // const getContratSelected = async (id) => {
    //   try {
    //     const response = await axios.get(`/contrats/${id}`);
    //     leContrat.value = response.data.data;
    //     // await calculerMontant();
    //   } catch (error) {
    //     console.error("Error fetching contrat:", error);
    //   }
    // };


    const checkPermission = (name) => {
      return privileges.value.includes(name);
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());
    const calculerMontant = () => {
      const contrat = leContrat.value;
      if (contrat) {
        if (natureFacture.value == 0) {
          montant_facture.value = contrat.loyer || 0;
        } else if (natureFacture.value == 2) {
          montant_facture.value = contrat.contratElements.reduce((acc, element) => acc + element.prix * element.quantite, 0);
        } else if (natureFacture.value == 3) {
          montant_facture.value = (contrat.loyer || 0) + contrat.contratElements.reduce((acc, element) => acc + element.prix * element.quantite, 0);
        } else {
          montant_facture.value = 0;
        }
      } else {
        montant_facture.value = 0;
      }

    }

    watch(natureFacture, async (newValue) => {
      await calculerMontant();
      // const contratI = leContrat.value;
      // if (contratI !== null) {
      //   if (newValue == 0) {
      //     montant_facture.value = contratI.loyer || 0;
      //   } else if (newValue == 2) {
      //     montant_facture.value = contratI.contratElements.reduce((acc, element) => acc + element.prix * element.quantite, 0);
      //   } else if (newValue == 3) {
      //     montant_facture.value = (contratI.loyer || 0) + contratI.contratElements.reduce((acc, element) => acc + element.prix * element.quantite, 0);
      //   } else {
      //     montant_facture.value = 0;
      //   }
      // }

    });


    return {
      normalise,
      factureSchema,
      addFacture,
      auclic,
      factureForm,
      contratOptions,
      contrat,
      years,
      minPeriode,
      montant_facture,
      fetchContrats,
      contrats,
      natureFacture,
      nooptions,
      noOptionsTextAbb,
      date_facture,
      mois,
      aib,
      showAib,
      montant_aib,
      nbElementsofContrat,
      contratSelect,
      checkPermission,
      dateLimit
    };
  },
});
</script>
